import React, { memo, useState } from 'react';
import { Modal, withStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import PF2MFullScreenButton from '~/components/PF2MFullScreenButton';
import PF2MIconButton from '~/components/PF2MIconButton';
import PF2MTooltip from '~/components/PF2MTooltip';
import styles from './styles';
import CleanFilterIcon from '~/assets/clean_filter.svg';
import notePencilIcon from '~/assets/notePencilIcon.svg';
import EquipmentFiltersSelect from './EquipmentFiltersSelect';
import EquipmentStatusEditAllModal from '../EquipmentStatusEditAllModal';
import PF2MSwitch from '~/components/PF2MSwitch';
import { setCurrentEquipmentStatusFilterV3 } from '~/store/dispatch/actions';

const EquipmentFilters = memo(
  ({
    handleFS,
    formFields,
    handleChange,
    handleChangeMultiple,
    handleClean,
    currentFilter,
    classes,
  }) => {
    const [modalAllOpen, setModalAllOpen] = useState(false);
    const { t: translate } = useTranslation();
    const dispatch = useDispatch();

    return (
      <div className={classes.containerWrapperEquipFilters}>
        <div className={classes.wrapperEquipFiltersActions}>
          <EquipmentFiltersSelect
            formFields={formFields}
            handleChange={handleChange}
            handleChangeMultiple={handleChangeMultiple}
            handleClean={handleClean}
          />
          <div className={classes.actionsButtons}>
            <div className={classes.switchContainer}>
              <span className={classes.subtitle}>{translate('common:Legend')}</span>
              <PF2MSwitch
                checked={currentFilter.isStatusEquipmentSubtitleOn}
                onChange={(e) => {
                  dispatch(setCurrentEquipmentStatusFilterV3({
                    ...currentFilter,
                    isStatusEquipmentSubtitleOn: e.target.checked,
                  }));
                }}
              />
            </div>
            <PF2MTooltip
              title={translate('common:ClearFilters')}
              PopperProps={{ disablePortal: true }}
            >
              <PF2MIconButton
                icon={<img src={CleanFilterIcon} className={classes.icon} alt="" />}
                onClick={handleClean}
                variant="filled"
                color="primary"
                buttonStyles={{ height: '34px', width: '34px' }}
              />
            </PF2MTooltip>
            <PF2MTooltip
              title={translate('common:EditRecordsInBatches')}
              PopperProps={{ disablePortal: true }}
            >
              <PF2MIconButton
                icon={<img src={notePencilIcon} alt="edit" />}
                onClick={() => setModalAllOpen(true)}
                variant="filled"
                color="primary"
                buttonStyles={{ height: '34px', width: '34px' }}
              />
            </PF2MTooltip>
            <PF2MFullScreenButton
              variant="outlined"
              isFullScreenActive={handleFS.active}
              open={handleFS.enter}
              close={handleFS.exit}
              iconButtonClasses={classes.fullScreenButton}
            />
          </div>
        </div>
        <Modal
          open={modalAllOpen}
          onBackdropClick={() => setModalAllOpen(false)}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          container={document.fullscreenElement || document.body}
        >
          <EquipmentStatusEditAllModal
            handleOpen={() => setModalAllOpen(true)}
            handleClose={() => setModalAllOpen(false)}
          />
        </Modal>
      </div>
    );
  },
);

EquipmentFilters.propTypes = {
  classes: PropTypes.object.isRequired,
  handleFS: PropTypes.shape({
    active: PropTypes.bool.isRequired,
    enter: PropTypes.func.isRequired,
    exit: PropTypes.func.isRequired,
  }).isRequired,
  formFields: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleChangeMultiple: PropTypes.func.isRequired,
  handleClean: PropTypes.func.isRequired,
  currentFilter: PropTypes.object.isRequired,
};

export default withStyles(styles)(EquipmentFilters);
